import _ from 'lodash'

import { RETAILER_USER_TYPE } from '@/constants/constants'

const VueCan = {
  install(app, options) {
    const { store } = options
    app.config.globalProperties.$can = (permission, checkAdmin = true) => {
      const permissions = store.state.auth.permissions

      if (store.state.auth.isAdmin === true && checkAdmin) {
        return true
      } else if (_.isArray(permission)) {
        let result = true
        permission.forEach(function (p) {
          if (!permissions.includes(p)) {
            result = false
          }
        })
        return result
      } else if (permissions.includes(permission)) {
        return true
      }

      return false
    }

    app.config.globalProperties.$retailerCan = (user, roles = []) => {
      if (user.is_owner === RETAILER_USER_TYPE.OWNER) {
        return true
      }

      if (!roles.length) {
        return false
      }

      return roles.includes(user.role)
    }

    const $can = app.config.globalProperties.$can
    const $retailerCan = app.config.globalProperties.$retailerCan

    app.provide('VueCan', { $can, $retailerCan })
  }
}

export default VueCan
